import React, { useState } from 'react';
import { FAQ } from './Data';
import './FAQs.css';
import TechIcon from '../../../Utils/Icons/Icons';

const FaqItem = ({ question, description }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faqContainer">
      <button className="faqQuestion" onClick={toggleOpen}>
        <span>{question}</span>
        {isOpen ? <TechIcon name="chevron-up" size={20} /> : <TechIcon name="chevron-down" size={20} />}
      </button>
      <div className={`faqAnswer ${isOpen ? 'open' : ''}`}>
        <p>{description}</p>
      </div>
    </div>
  );
};

const FAQSection = () => {
  return (
    <section className="faqSection">
      <div className="faqWrap">
        <div className="faqContent">
          <h1>
            Question and<br />
            <span>Answers</span>
          </h1>
        </div>
        <div className="faqRightColumn">
          {FAQ.map((item, index) => (
            <FaqItem key={index} question={item.question} description={item.description} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;